export default function CountertopsHero() {
  return (
    <section className="relative bg-gradient-to-br from-amber-50 to-amber-100 pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-amber-700 text-white text-sm font-medium rounded-full mb-6">
              El Paso Countertop Specialists
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Premium Granite, Quartz & Countertop Contractors in El Paso
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Transform your kitchen or bathroom with beautiful, durable countertops. Connect with expert fabricators and installers offering granite, quartz, marble, and more. Get free quotes from trusted El Paso contractors.
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#directory" 
                className="px-8 py-4 bg-amber-700 text-white font-semibold rounded-lg hover:bg-amber-800 transition-colors shadow-lg whitespace-nowrap"
              >
                Find Countertop Contractors
              </a>
              <a 
                href="#materials" 
                className="px-8 py-4 bg-white text-amber-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors border-2 border-amber-700 whitespace-nowrap"
              >
                Explore Materials
              </a>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/7c2c8157a8c18fb59b1bdef473fcb106.jpg"
              alt="Granite and Quartz Countertops El Paso"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
